
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.875 2.188A4.663 4.663 0 008.558 3.56L2.815 9.305a.939.939 0 001.326 1.329l5.746-5.748a2.815 2.815 0 013.978 3.978l-6.63 6.628a.937.937 0 01-1.324-1.325L12.54 7.54a.94.94 0 10-1.328-1.329l-6.63 6.631A2.815 2.815 0 008.56 16.82l6.628-6.629a4.657 4.657 0 001.374-3.315 4.692 4.692 0 00-4.687-4.687z","fill":"#282E3E"}})])
          )
        }
      }
    